/* eslint-disable no-console */
import {
    CompressedStorageClient,
    getExternalAssessmentIndexedDBClient,
} from '@amplify/web-assessment-common/dist/storage';
import AssessmentStorageClient from './AssessmentStorageClient';

class CLPLOfflineStorage extends AssessmentStorageClient {
    /**
     * Initialize internal data source clients.
     * Takes clients that represent asynchronous and synchronous storages,
     * though both require to implement Storage API in order to be interchangeable.
     * @param {Boolean} [loggingEnabled=false] whether to post errors to console
     * @param {Storage} [storageAsync=indexedDB client] instance of client that implements Storage API
     * @param {Storage} [storageSync=localStorage] instance of client that implements Storage API
     */
    constructor(
        loggingEnabled,
        storageAsync = getExternalAssessmentIndexedDBClient(),
        storageSync = localStorage,
    ) {
        super(loggingEnabled, storageAsync, storageSync);
        this.goalsAndZoGClient = new CompressedStorageClient(storageAsync);
    }

    CUTSCORES_KEY = 'clpl_cutscores';

    FORMS_KEY = 'clpl_forms';

    /*
    FORMS_BLACKLIST_DETAILS_KEYS = [
        'assessment',
        'itemsMetadata',
        'lines',
        'maxScore',
        'totalLines',
        'version',
        'items',
        'paragraphs',
    ];

    CUTSCORES_BLACKLIST_DETAILS_KEYS = ['thresholds', 'uid', 'maxScore', 'preliminaryGoalScore'];
    */
}

export default CLPLOfflineStorage;
